namespace $ {
	export type $shm_surreal_config_profile_data = {
		endpoint: string
		namespace: string
		database: string
		username?: string
		password?: string
		token?: string
	}

	export type $shm_surreal_config_query_request = {
		statement: string
		bindings?: Record< string, unknown >
		tables?: readonly string[]
	}

	export function $shm_surreal_config_identifier( value: string ) {
		if( !/^[\p{L}_][\p{L}\p{N}_]*$/u.test( value ) ) {
			throw new Error( `Недопустимое имя SurrealDB: ${ value }` )
		}
		return `\`${ value }\``
	}

	export function $shm_surreal_config_endpoint( endpoint: string ) {
		const normalized = endpoint.trim().replace( /\/$/, '' )
		if( !/^(?:wss?|https?):\/\//i.test( normalized ) ) {
			throw new Error( 'Адрес SurrealDB должен начинаться с ws://, wss://, http:// или https://' )
		}
		return normalized.endsWith( '/rpc' ) ? normalized : `${ normalized }/rpc`
	}

	export function $shm_surreal_config_query_key( request: $shm_surreal_config_query_request ) {
		return JSON.stringify({
			statement: request.statement,
			bindings: request.bindings ?? {},
			tables: [ ... new Set( request.tables ?? [] ) ].sort(),
		})
	}
}
